import css from './ViewAllTemplatesPreview.module.css';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import ViewTemplatesIcon from '@modules/Landing/Shared/Icons/ViewTemplatesIcon';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@configs/AppRoutes';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import landingTemplates from '@assets/Imgs/landingTemplatesImg.svg';
import landingTemplatesMobile from '@assets/Imgs/landingTemplatesImgMobile.svg';

export const ViewAllTemplatesPreview: React.FC = () => {
    const [isDesktop, isTablet, isMobile] = useMediaType();
    const navigate = useNavigate();
    const handleNavigateToTemplatesPage = () => {
        navigate(ROUTES.TEMPLATES);
    };

    return (
        <div className={css.container}>
            <img
                src={isDesktop ? landingTemplates : landingTemplatesMobile}
                className={css.img}
            />
            <div className={css.text}>
                Try our free and paid templates for building and renovation
                projects.
            </div>
            <BasicButton
                extraClassName={css.btn}
                onClick={handleNavigateToTemplatesPage}
            >
                <div className={css.btnContent}>
                    <ViewTemplatesIcon
                        stroke={'currentColor'}
                        fill={'none'}
                        className={css.iconSvg}
                    />
                    View all templates
                </div>
            </BasicButton>
        </div>
    );
};
